import urls from '../constants/urls'

export const PENDING_INVITE_DESTROY_FAILED = 'pendingInvites/DESTROY_FAILED'
export const PENDING_INVITE_DESTROY_SUCCESS = 'pendingInvites/DESTROY_SUCCESS'
export const DESTROYING_PENDING_INVITE = 'pendingInvites/DESTROYING'

export const PENDING_INVITES_LOAD_FAILED = 'pendingInvites/LOAD_FAILED'
export const PENDING_INVITES_LOAD_SUCCESS = 'pendingInvites/LOAD_SUCCESS'
export const LOADING_PENDING_INVITES = 'pendingInvites/LOADING'

const initialState = {
  pendingInvites: [],

  failedDestroying: false,
  failedLoading:    false,

  hasLoaded: false,

  isDestroying: false,
  isLoading:    false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DESTROYING_PENDING_INVITE:
      return {
        ...state,
        isDestroying:     true,
        failedDestroying: false
      }

    case PENDING_INVITE_DESTROY_SUCCESS:
      return {
        ...state,
        isDestroying: false
      }

    case PENDING_INVITE_DESTROY_FAILED:
      return {
        ...state,
        isDestroying:     false,
        failedDestroying: true
      }

    case LOADING_PENDING_INVITES:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case PENDING_INVITES_LOAD_SUCCESS:
      return {
        ...state,
        pendingInvites: action.payload.data,
        pages:          action.payload.headers['x-pages'],
        page:           action.payload.headers['x-total'],
        total:          action.payload.headers['x-total'],
        isLoading:      false,
        failedLoading:  false,
        hasLoaded:      true
      }

    case PENDING_INVITES_LOAD_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    default:
      return state
  }
}

export const loadPendingInvites = (hospital, page, searchTerm) => (dispatch) => {
  return dispatch({
    types:   [LOADING_PENDING_INVITES, PENDING_INVITES_LOAD_SUCCESS, PENDING_INVITES_LOAD_FAILED],
    payload: {
      request: {
        url:    urls.hospitals.invites.pending.index(hospital.id),
        params: { page, search_string: searchTerm }
      }
    }
  })
}

export const destroyPendingInvite = (hospitalId, inviteId) => (dispatch) => {
  return dispatch({
    types:   [DESTROYING_PENDING_INVITE, PENDING_INVITE_DESTROY_SUCCESS, PENDING_INVITE_DESTROY_FAILED],
    payload: {
      request: {
        method: 'delete',
        url:    urls.hospitals.invites.pending.destroy(hospitalId, inviteId)
      }
    }
  })
}
